import { defineStore } from 'pinia'
// Jawny import zamiast auto-importu Nuxt — store musi działać też w unit
// testach (Node env bez unimport), jak notificationsStore.
import { computed, ref } from 'vue'

export type CheckoutStep = 'contact' | 'shipping' | 'delivery' | 'payment' | 'summary'

export const CHECKOUT_STEPS: CheckoutStep[] = ['contact', 'shipping', 'delivery', 'payment', 'summary']

export type PushSheetContext = 'add-to-cart' | 'login' | 'register'

export const useUIStore = defineStore('ui', () => {
  const activeCheckoutStep = ref<CheckoutStep>('contact')
  const isModalOpen = ref(false)
  const modalContent = ref<string | null>(null)
  const pushSheetContext = ref<PushSheetContext | null>(null)

  function setCheckoutStep(step: CheckoutStep) {
    activeCheckoutStep.value = step
  }

  function nextCheckoutStep() {
    const currentIndex = CHECKOUT_STEPS.indexOf(activeCheckoutStep.value)
    if (currentIndex < CHECKOUT_STEPS.length - 1) {
      activeCheckoutStep.value = CHECKOUT_STEPS[currentIndex + 1]!
    }
  }

  function prevCheckoutStep() {
    const currentIndex = CHECKOUT_STEPS.indexOf(activeCheckoutStep.value)
    if (currentIndex > 0) {
      activeCheckoutStep.value = CHECKOUT_STEPS[currentIndex - 1]!
    }
  }

  function resetCheckout() {
    activeCheckoutStep.value = 'contact'
  }

  function openModal(content?: string) {
    modalContent.value = content ?? null
    isModalOpen.value = true
  }

  function closeModal() {
    isModalOpen.value = false
    modalContent.value = null
  }

  function openPushPermissionSheet(context: PushSheetContext): void {
    pushSheetContext.value = context
  }

  function closePushPermissionSheet(): void {
    pushSheetContext.value = null
  }

  // „Zobacz wszystkie kategorie” z mobilnego drawera: drawer zapamiętuje tu
  // ścieżkę listingu PRZED nawigacją, a ProductFilters na stronie docelowej
  // konsumuje i otwiera modal filtrów. Ścieżka (nie boolean), żeby stale flag
  // z przerwanej nawigacji nie otworzyła modala na innej stronie kategorii.
  const mobileFiltersOpenRequestPath = ref<string | null>(null)

  function requestMobileFiltersOpen(path: string): void {
    mobileFiltersOpenRequestPath.value = path
  }

  function consumeMobileFiltersOpenRequest(currentPath: string): boolean {
    const requestedPath = mobileFiltersOpenRequestPath.value
    if (requestedPath === null) {
      return false
    }
    mobileFiltersOpenRequestPath.value = null
    return requestedPath === currentPath
  }

  const checkoutStepIndex = computed(() => CHECKOUT_STEPS.indexOf(activeCheckoutStep.value))

  return {
    activeCheckoutStep,
    checkoutStepIndex,
    isModalOpen,
    modalContent,
    pushSheetContext,
    setCheckoutStep,
    nextCheckoutStep,
    prevCheckoutStep,
    resetCheckout,
    openModal,
    closeModal,
    openPushPermissionSheet,
    closePushPermissionSheet,
    mobileFiltersOpenRequestPath,
    requestMobileFiltersOpen,
    consumeMobileFiltersOpenRequest,
  }
})
